import { KeyedFontAsset } from '../stores/types/font-assets';
import { Theme, ThemeMaps } from '../stores/types/themes';
import { getEmbedSafeHeaders } from './auth';
import blpAuth from './blp-auth';
import { getApiHost, getSyncHost } from '../utils/hosts';

export const SetThemeFont = async (
	roomId: number,
	themeId: number,
	fontAssetId: number,
	associatedKey: string
): Promise<boolean> => await blpAuth.put({
	host: getSyncHost(),
	url: `/v1/room/${roomId}/themes/set-font`,
	token: blpAuth.accessToken,
	options: {headers: getEmbedSafeHeaders()},
	body: {
		themeId,
		fontAssetId,
		associatedKey
	},
}).catch((err) => {
	console.error('error setting theme font: ', err);
	return false;
}).then((res) => res === "OK");

export const GetThemeFonts = async (
	roomId: number,
	themeId: number
): Promise<null | KeyedFontAsset> => await blpAuth.get({
	host: getSyncHost(),
	url: `/v1/room/${roomId}/themes/${themeId}/fonts`,
	token: blpAuth.accessToken,
	options: {headers: getEmbedSafeHeaders()},
}).catch((err) => {
	console.error('error getting theme fonts: ', err);
	return null;
}).then((res) => res);

export const LoadThemes = (
	channel: number
): Promise<Theme[]> => blpAuth.get({
	url: `/v3/greenroom/themes/channel/${channel}`,
	host: getApiHost(),
	token: blpAuth.accessToken,
	options: { headers: getEmbedSafeHeaders() },
}).catch((e) => {
	console.error('Error loading themes:', e);
	return [];
}).then((res) => res);

export const LoadDefaultThemes = (): Promise<Theme[]> => blpAuth.get({
	url: `/v3/greenroom/themes/default`,
	host: getApiHost(),
	token: blpAuth.accessToken,
	options: { headers: getEmbedSafeHeaders() },
}).catch((e) => {
	console.error('Error loading default themes:', e);
	return [];
}).then((res) => res);

export const LoadThemeMaps = (
	channel: number
): Promise<ThemeMaps | null> => blpAuth.get({
	url: `/v3/greenroom/themes/${channel}/maps`,
	host: getApiHost(),
	token: blpAuth.accessToken,
	options: { headers: getEmbedSafeHeaders() }
}).catch((e) => {
	console.error('Error loading theme maps:', e);
	return null;
}).then((res) => res);

export const UpsertTheme = (
	channel: number,
	theme: Partial<Theme>
): Promise<any[]> => blpAuth.put({
	url: `/v3/greenroom/themes/${channel}/upsert`,
	host: getApiHost(),
	token: blpAuth.accessToken,
	options: { headers: getEmbedSafeHeaders() },
	body: theme
}).catch((e) => {
	console.error('Error upserting a theme:', e);
	return [];
}).then((res) => res);

interface DeleteThemeResponse {
	deleted: boolean;
	newThemeIds: number[];
}

export const DeleteTheme = (
	channel: number,
	themeId: number
): Promise<DeleteThemeResponse> => blpAuth.delete({
	url: `/v3/greenroom/themes/${channel}/delete/${themeId}`,
	host: getApiHost(),
	token: blpAuth.accessToken,
	options: { headers: getEmbedSafeHeaders() }
}).catch((e) => {
	console.error('Error deleting theme:', e);
	return { deleted: false, newThemeIds: [] };
}).then((res) => {
	return res;
});